module.exports = __webpack_public_path__ + "static/backlog-d115282fab0d76d7f17de61a8ab092c0.png";